import moment from 'moment';

// Helper function to determine which festival theme to show
export const getFestivalTheme = () => {
  const now = moment();
  const month = now.month() + 1; // moment months are 0-indexed
  const date = now.date();

  // Christmas: December 1 - December 31
  if (month === 12) {
    return "christmas";
  }

  // New Year: January 1 - February 1
  if (month === 1 || (month === 2 && date === 1)) {
    return "newyear";
  }

  return null;
};

// Helper function to determine if snow should be shown
export const shouldShowSnow = () => {
  const now = moment();
  const month = now.month() + 1; // moment months are 0-indexed
  const date = now.date();

  // Snow: October 1 - March 15
  // Show from October (10) through December (12), January (1), February (2), and March 1-15 (3)
  if (month >= 10 || month <= 2) {
    return true;
  }

  if (month === 3 && date <= 15) {
    return true;
  }

  return false;
};
